import React from 'react'
import styled from '../../styled/styled-components'

export const StyleNavigationLogoIcon = () => (
  <svg
    width="32"
    height="25"
    viewBox="0 0 32 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.2836 19.933L29.2427 18.6477L26.9163 14.1798L21.6514 2.42843H19.3251L15.3458 8.91614L11.1829 2L8.79536 2.36723L2 19.627L9.52999 22.2588L11.2441 16.6892L13.8766 20.9123H15.958L19.2027 16.1995L21.529 22.32L27.2836 19.933Z"
      stroke="white"
      strokeWidth="3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3458 10.8748L19.8761 3.53019H20.978L27.8346 18.6478L22.08 21.0348L19.4475 14.0574L15.407 19.9331H14.4275L10.8768 14.3022L8.85655 20.9736L3.3468 19.0762L9.52997 3.34658L10.6319 3.16296L15.3458 10.8748Z"
      fill="#050302"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0198 3.89739L10.2646 3.83618L15.2846 12.2212L20.2434 4.14221H20.4883L26.8551 18.1581L22.5085 19.9943L19.6312 12.4661L15.0398 19.1374H14.8561L10.632 12.5273L8.36684 19.9943L4.26514 18.5253L10.0198 3.89739Z"
      fill="#E32D2D"
    />
  </svg>
)
export const StyledNavigationLogoWrapper = styled.div`
  margin-left: 28px;
  margin-top: 30px;
  width: 50px;
  height: 50px;
  background: #78b833;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const StyledNavigationLogoHeadline = styled.div`
  margin-left: 28px;
  margin-right: 28px;
  margin-top: 19px;
  font-size: 24px;
  line-height: 28px;
  color: #000;
  position: relative;
  border-bottom: 1px solid #e7e7e9;
  padding-bottom: 27px;
  box-sizing: border-box;
`
export const StyledNavigation = styled.div`
  div[class^='NavigationGlobalNavigationWrapper'] {
    display: none;
  }

  div[class^='RevealInne'] {
    display: none;
  }

  div[class^='ContainerHeaderWrapper'] button {
    overflow: hidden;
  }

  div[class^='NestedNavigationPage'] {
    padding: 0 16px 0 3px;
    margin-top: 27px;
    left: 14px;
    position: relative;
  }
  div[class^='NavigationItemGroupTitle'] {
    font-size: 11px;
    line-height: 13px;
    color: #696974;
    mix-blend-mode: normal;
    opacity: 0.5;
    left: 8px;
    position: relative;
  }
  div[class^='ContainerNavigationInner'] {
    background: #f5f9fc;
  }
  div[class^='ScrollHintScrollContainer'] {
    :before,
    :after {
      background: #f5f9fc;
    }
  }
  div[class^='NestedNavigationPage'] {
    :before,
    :after {
      background: #f5f9fc;
    }
  }
`
export const StyledMarketplaceIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  box-shadow: 0 2px 5px 0 rgba(60, 66, 87, 0.1), 0 1px 1px 0 rgba(0, 0, 0, 0.07);
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 6px;
`
export const StyledItem = styled.div`
  * {
    font-size: 18px;
    line-height: 40px;
    color: #000000;
    background-color: #0000 !important;
  }
`
